// Route guard for the employee "Loans & Advances" page: renders it only when the
// employer's loans toggle is on (credit.tenant_settings.show_employee_loans). A deep
// link when hidden redirects to the dashboard, mirroring the nav gate in
// TenantAwareNavigationSidebar. Employee-facing only — admin loan pages are not gated.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEntitlements } from '@/features/entitlements/useEntitlements';
import { useMarketplaceVisible } from './useMarketplaceVisible';
import { MyLoansPage } from '@/features/payroll';

export default function MyLoansRoute() {
  const { hasProduct } = useEntitlements();
  const hasCredit = hasProduct('credit');
  const { loaded, loansVisible } = useMarketplaceVisible(hasCredit);

  if (!hasCredit) return <Navigate to=".." replace />;
  if (!loaded) return null; // brief: waiting on the visibility check
  if (!loansVisible) return <Navigate to=".." replace />;
  return <MyLoansPage />;
}
